module.exports = __webpack_public_path__ + "img/work3.c825d69b.gif";